import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuard } from './core';

const routes: Routes = [
  {
    path: 'administrar-cuenta',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'autorizaciones',
    loadChildren: () =>
      import('./authorizations/authorizations.module').then((m) => m.AuthorizationsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'ventas',
    loadChildren: () => import('./sale/sale.module').then((m) => m.SaleModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'configuracion',
    loadChildren: () =>
      import('./configuration/configuration.module').then((m) => m.ConfigurationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'operacion',
    loadChildren: () => import('./operation/operation.module').then((m) => m.OperationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reportes',
    loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'picking',
    loadChildren: () => import('./picking/picking.module').then((m) => m.PickingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'soporte-de-usuario',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'soporte-de-usuario-externo',
    loadChildren: () =>
      import('./userExternal/user-external.module').then((m) => m.UserExternalModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mantenimiento',
    loadChildren: () => import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'external',
    loadChildren: () => import('./external/external.module').then((m) => m.ExternalModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
